export const RENEW_CONTRACT_MODAL_WIZARD_PAGE = {
  PAGE_1_NEW_CONTRACT_SETTINGS: 0,
  PAGE_2_COVERED_LOCATIONS: 1,
  PAGE_3_FINALISE: 2,
} as const;
export type RENEW_CONTRACT_MODAL_WIZARD_PAGE = typeof RENEW_CONTRACT_MODAL_WIZARD_PAGE;
export type A_RENEW_CONTRACT_MODAL_WIZARD_PAGE = RENEW_CONTRACT_MODAL_WIZARD_PAGE[keyof RENEW_CONTRACT_MODAL_WIZARD_PAGE];
